export default __webpack_public_path__ + "static/media/plus-icon_white.ac4fc8d5.svg";